//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



/** AanvullingBerichtType AX = 0, LX = 1, DX = 2, KX = 3 */
export enum AanvullingBerichtType {
    AX = "AX",
    LX = "LX",
    DX = "DX",
    KX = "KX",
}

export interface ActionEventDetails {
    action: string | null;
    organisatie: string | null;
    vestiging: string | null;
    actor: string | null;
    timeStamp: string | null;
    description: string | null;
    vestigingId: string | null;
}

/** Output voor toevoegen en valideren van bemiddelingproducten */
export interface AddBemiddelingproductOutputModel {
    /** Id van het aangemaakte bemiddelingproduct */
    readonly bemiddelingproductId: string | null;
    /** Id van het aangemaakte hdnDossier */
    hdnDossierId: string | null;
    status: BemiddelingProductStatus;
    /** Gekoppelde hypotheek */
    readonly hypotheekId: string | null;
    /** Gekoppelde dekking */
    readonly dekkingId: string | null;
    /** Gekoppelde bankgarantie */
    readonly bankgarantieId: string | null;
    /** Gekoppelde taxatie */
    readonly taxatieId: string | null;
    /** De eventuele validatiemeldingen m.b.t. het HDN bericht */
    validatiemeldingen: HdnValidatiemeldingForm[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model waarop wordt bepaald of er een bemiddelingdossier wordt aangemaakt of wordt aangevult */
export interface AddOrUpdateBemiddelingdossierApiModel {
    /** Id van het adviesdossier */
    adviesdossierId: string;
    analyse: AnalyseApiModel;
    /** Bemiddelde dekkingen met de potentieel te vervangen bemiddelingproducten */
    dekkingen: DekkingApiModel[] | null;
    /** Gekozen bemiddelaarId */
    bemiddelaarId: string | null;
    /** Het e-mailadres van de gekozen bemiddelaar (indien deze geen id heeft) */
    bemiddelaarEmailadres: string | null;
    /** Taxatie meenemen */
    taxatieMeenemen: boolean;
    /** Bankgarantie meenemen */
    bankgarantieMeenemen: boolean;
}

export interface Adres {
    straat: string | null;
    huisnummer: number | null;
    toevoeging: string | null;
    postcode: string | null;
    locatie: string | null;
    plaats: string | null;
    landCode: string | null;
    landOmschrijving: string | null;
}

export interface AdresInput {
    straatnaam: string | null;
    huisnummer: string | null;
    toevoeging: string | null;
    postcode: string | null;
    landCode: string | null;
    land: string | null;
    plaats: string | null;
}

/** Bevat het advies dossier id. */
export interface AdviesdossierIdOutput {
    /** Het id van een adviesdossier. */
    adviesdossierId: string;
    /** Het id van de medewerker. */
    medewerkerId: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens van een adviseur */
export interface AdviseurModel {
    /** Het id van de toegevoegde adviseur */
    adviseurId: string | null;
    /** Het id van de toegevoegde adviseur */
    naam: string | null;
    /** Het id van de gekoppelde bemiddelaar */
    coupledBemiddelaarId: string | null;
    /** Het e-mailadres van de medewerker */
    emailadres: string | null;
}

/** Api model om een analyse naar een bemiddelingproduct om te zetten */
export interface AnalyseApiModel {
    /** Het Id van de analyse */
    analyseId: string | null;
    /** Het bemiddelingproduct id. */
    teVervangenBemiddelingProductId: string | null;
    /** De Service provider id. */
    serviceProviderId: string | null;
}

export interface BadRequestResult {
    statusCode: number;
}

/** Betreft het base product. Alle bemiddelde producten erven hiervan over. */
export interface BaseProduct {
    /** Id van het bemiddelingproduct */
    readonly bemiddelingproductId: string;
    /** De geldverstrekker */
    readonly naam: string | null;
    /** De geldverstrekker */
    readonly verstrekker: string | null;
    /** De geldverstrekker */
    readonly serviceProviderNaam: string | null;
    /** Het voorstel nummer */
    readonly voorstel: string | null;
    /** Geeft aan of dit, of een parent bemiddelingproduct, aangevraagd is */
    readonly aangevraagd: boolean;
    /** Datum waarop het eerste aangevraagde product aangevraagd is */
    readonly aangevraagdOp: string | null;
    /** De versie van het bemiddelde product */
    readonly versie: number;
    /** De datum waarop het product bemiddeld is */
    readonly datum: string | null;
    /** Bevat de gekoppelde documenten */
    readonly documenten: Document[] | null;
    /** Is in behandeling na aanvragen */
    isInBehandeling: boolean;
    /** Bevat het gekoppelde HDNDossier Id */
    hdnDossierId: string | null;
}

/** Het input model voor Intersoftware.Adviesbox.Data.BelangrijkeDatumActie */
export interface BelangrijkeDatumActieInputModel {
    /** Het aantal x het gekozen IntervalType. */
    intervalAantal: number;
    intervalType: BelangrijkeDatumActieIntervalType;
    actieType: BelangrijkeDatumActieType;
    ontvangerType: BelangrijkeDatumActieReceiverType;
}

/** BelangrijkeDatumActieIntervalType Uren = 1, Dagen = 24, Weken = 168 */
export enum BelangrijkeDatumActieIntervalType {
    Uren = "Uren",
    Dagen = "Dagen",
    Weken = "Weken",
}

/** Het output model van een Intersoftware.Adviesbox.Data.BelangrijkeDatumActie model. */
export interface BelangrijkeDatumActieOutputModel {
    /** Het unieke id van een belangrijke datum. */
    id: string;
    /** Het aantal x het gekozen IntervalType. */
    intervalAantal: number;
    intervalType: BelangrijkeDatumActieIntervalType;
    actieType: BelangrijkeDatumActieType;
    ontvangerType: BelangrijkeDatumActieReceiverType;
}

/** BelangrijkeDatumActieReceiverType Behandelaar = 0, Team = 1 */
export enum BelangrijkeDatumActieReceiverType {
    Behandelaar = "Behandelaar",
    Team = "Team",
}

/** BelangrijkeDatumActieType Notificatie = 0, Mail = 1 */
export enum BelangrijkeDatumActieType {
    Notificatie = "Notificatie",
    Mail = "Mail",
}

/** Het input model voor het N:Intersoftware.Platform.Klantdossiers.Bemiddeling.WebAPI.Models.BelangrijkeDatum model. */
export interface BelangrijkeDatumInputModel {
    /** De omschrijving van de belangrijke datum. */
    omschrijving: string | null;
    /** De datum waarop de belangrijke datum verloopt. */
    datum: string | null;
    /** De gekoppelde acties. */
    gekoppeldeActies: BelangrijkeDatumActieInputModel[] | null;
    /** Foreign key: het ID van het bemiddeling product. */
    bemiddelingproductId: string;
    predefinedType: BelangrijkeDatumPredefinedType;
}

/** Het output model van een N:Intersoftware.Platform.Klantdossiers.Bemiddeling.WebAPI.Models.BelangrijkeDatum model. */
export interface BelangrijkeDatumOutputModel {
    /** Het unieke id van een belangrijke datum. */
    id: string;
    /** De status van een belangrijke datum (actief/niet actief). */
    actief: boolean;
    /** De omschrijving van de belangrijke datum. */
    omschrijving: string | null;
    /** De datum waarop de belangrijke datum verloopt. */
    datum: string | null;
    predefinedType: BelangrijkeDatumPredefinedType;
    /** De gekoppelde acties. */
    gekoppeldeActies: BelangrijkeDatumActieOutputModel[] | null;
    /** Foreign key: het ID van het bemiddeling product. */
    bemiddelingproductId: string;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** BelangrijkeDatumPredefinedType HypotheekBankgarantieStellen = 0, HypotheekOntbindendeVoorwaarden = 1, HypotheekDefinitievePasseerdatum = 2, HypotheekAflosnotaGeldigTot = 3, HypotheekDatumAflosnotaOpvragenDoorNotaris = 4, HypotheekRenteaanbodGetekendRetour = 5, HypotheekRenteaanbodGeldigheid = 6, HypotheekBindendeOfferteGetekendRetour = 7, HypotheekBindendeOfferteGeldigheidsdatumInclRetour = 8, VerzekeringVerwachteIngangsdatum = 9 */
export enum BelangrijkeDatumPredefinedType {
    HypotheekBankgarantieStellen = "HypotheekBankgarantieStellen",
    HypotheekOntbindendeVoorwaarden = "HypotheekOntbindendeVoorwaarden",
    HypotheekDefinitievePasseerdatum = "HypotheekDefinitievePasseerdatum",
    HypotheekAflosnotaGeldigTot = "HypotheekAflosnotaGeldigTot",
    HypotheekDatumAflosnotaOpvragenDoorNotaris = "HypotheekDatumAflosnotaOpvragenDoorNotaris",
    HypotheekRenteaanbodGetekendRetour = "HypotheekRenteaanbodGetekendRetour",
    HypotheekRenteaanbodGeldigheid = "HypotheekRenteaanbodGeldigheid",
    HypotheekBindendeOfferteGetekendRetour = "HypotheekBindendeOfferteGetekendRetour",
    HypotheekBindendeOfferteGeldigheidsdatumInclRetour = "HypotheekBindendeOfferteGeldigheidsdatumInclRetour",
    VerzekeringVerwachteIngangsdatum = "VerzekeringVerwachteIngangsdatum",
}

/** Het input model voor het aanpassen van een datum van een N:Intersoftware.Platform.Klantdossiers.Bemiddeling.WebAPI.Models.BelangrijkeDatum model. */
export interface BelangrijkeDatumUpdateDatum {
    /** De datum waarop de belangrijke datum verloopt. */
    datum: string | null;
}

/** Het input model voor het N:Intersoftware.Platform.Klantdossiers.Bemiddeling.WebAPI.Models.BelangrijkeDatum model. */
export interface BelangrijkeDatumUpdateModel {
    /** De status van een belangrijke datum (actief/niet actief). */
    actief: boolean;
    /** De omschrijving van de belangrijke datum. */
    omschrijving: string | null;
    /** De datum waarop de belangrijke datum verloopt. */
    datum: string | null;
    predefinedType: BelangrijkeDatumPredefinedType;
    /** De gekoppelde acties. */
    gekoppeldeActies: BelangrijkeDatumActieInputModel[] | null;
    /** Foreign key: het ID van het bemiddeling product. */
    bemiddelingproductId: string;
}

/** het output model van meerdere belangrijke datums, gekoppeld aan een bemiddeling product. */
export interface BelangrijkeDatumsOutputModel {
    /** De lijst met de gekoppelde belangrijke datums. */
    belangrijkeDatums: BelangrijkeDatumOutputModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens van een bemiddelaar */
export interface BemiddelaarModel {
    /** Het id van de bemiddelaar */
    bemiddelaarId: string | null;
    /** Het id van de bemiddelaar */
    naam: string | null;
    /** Emailadres van de bemiddelaar */
    emailadres: string | null;
}

/** BemiddelingProductStatus InBehandeling = 1, Vervallen = 2, NietValide = 3 */
export enum BemiddelingProductStatus {
    InBehandeling = "InBehandeling",
    Vervallen = "Vervallen",
    NietValide = "NietValide",
}

/** Output voor aanmaken of vullen van een bemiddelingdossier */
export interface BemiddelingdossierOutputModel {
    /** Id van het bemiddelingdossier */
    bemiddelingdossierId: string;
    /** Output van de aangemaakte bemiddelingproducten */
    bemiddelingproducten: AddBemiddelingproductOutputModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model om bestanden te koppelen aan HdnDxBerichten. */
export interface CoupleDocumentApiModel {
    /** Id van het klantsamenstellingdocument */
    klantsamenstellingdocumentId: string | null;
    /** Id van het HdnDxBericht */
    hdnDxBerichtId: string;
}

/** Bevat het pad van de folder */
export interface CreateFolderApiModel {
    /** Het pad van de folder */
    folderLocatie: string | null;
}

/** Api model om een dekking naar een bemiddelingproduct om te zetten */
export interface DekkingApiModel {
    /** Het id van de dekking. */
    dekkingId: string;
    /** Het bemiddelingproduct id. */
    teVervangenBemiddelingProductId: string | null;
    /** De Service provider id. */
    serviceProviderId: string | null;
}

/** Bevat het document */
export interface Document {
    /** De bestandnaam */
    readonly bestandNaam: string | null;
    documentStatus: HdnDocumentstatus;
}

/** Bevat het id van het te verzenden bemiddelingproduct */
export interface DocumentSendApiModel {
    /** Het id van het bemiddelingproduct */
    hdnBerichtIds: string[] | null;
}

/** Bevat de geegevens van het verzonden document */
export interface DocumentSendOutputModel {
    /** Het id van een hdnBericht */
    hdnBerichtId: string;
    /** De eventuele validatiemeldingen m.b.t. het HDN bericht */
    validatiemeldingen: HdnValidatiemeldingForm[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** DocumentTypeOptions KlantDocument = 0, HdnDocument = 1, RapportDocument = 2, Folder = 3 */
export enum DocumentTypeOptions {
    KlantDocument = "KlantDocument",
    HdnDocument = "HdnDocument",
    RapportDocument = "RapportDocument",
    Folder = "Folder",
}

/** Bevat de gegevens van de verzonden documenten */
export interface DocumentenSendOutputModel {
    /** De eventuele validatiemeldingen m.b.t. het HDN bericht */
    documentOutputModels: DocumentSendOutputModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model voor uitgaande en inkomende documenten. */
export interface DocumentsResultModel {
    inkomendeDocumenten: IncomingDocument[] | null;
    aanTeLeverenDocumenten: NecessaryDocument[] | null;
    aangeleverdeDocumenten: ProvidedDocument[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van bemiddeling dossiers */
export interface Dossier {
    aanvrager1: DossierAanvrager;
    aanvrager2: DossierAanvrager;
    dossiergegevens: Dossiergegevens;
    kantoorgegevens: Kantoorgegevens;
}

/** Bevat de gegevens van een aanvrager. */
export interface DossierAanvrager {
    /** TelefoonMobiel */
    readonly telefoonMobiel: string | null;
    /** Email */
    readonly email: string | null;
    adres: Adres;
    /** NationaliteitCode */
    readonly nationaliteitCode: string | null;
    /** Geboortenaam */
    readonly geboortenaam: string | null;
    readonly klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

/** Bevat de gegevens van een bemiddelaar. */
export interface DossierBehandelaar {
    /** Achternaam */
    readonly achternaam: string | null;
    /** Voorvoegsel */
    readonly voorvoegsel: string | null;
    /** Voorletters */
    readonly voorletters: string | null;
    /** Roepnaam */
    readonly voornamen: string | null;
}

/** Output voor het opvragen van bemiddeling dossiers */
export interface DossierOutput {
    /** Lijst met bemiddeling dossiers */
    dossiers: { [key: string]: Dossier; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de dossiergegevens. */
export interface Dossiergegevens {
    dossierstatus: Dossierstatus;
    status: Dossierstatus;
    /** KorteOmschrijving */
    readonly korteOmschrijving: string | null;
    /** LangeOmschrijving */
    readonly langeOmschrijving: string | null;
}

/** Dossierstatus Geen = 0, InBehandeling = 1, Actief = 2, NietActief = 3 */
export enum Dossierstatus {
    Geen = "Geen",
    InBehandeling = "InBehandeling",
    Actief = "Actief",
    NietActief = "NietActief",
}

/** Model de links naar de te downloaden bestanden */
export interface DownloadResultApiModel {
    /** Bevat de links naar de te downloaden bestanden */
    fileDownloadUrls: string[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de verschillende soorten events */
export interface EventsOutputModel {
    actionEvents: ActionEventDetails[] | null;
    hdnBerichtBemiddeldEvents: HdnBerichtBemiddeldEventDetails[] | null;
    hdnBerichtIncomeEvents: HdnBerichtIncomeEventDetails[] | null;
    hdnBerichtUpdateEvents: HdnBerichtUpdateEventDetails[] | null;
}

/** GeslachtOpties Geen = 0, Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Geen = "Geen",
    Man = "Man",
    Vrouw = "Vrouw",
}

/** Geeft de adviseurs en bemiddelaars van een vestiging terug */
export interface GetAdviseursAndBemiddelaarsApiOutputModel {
    /** Het id van de toegevoegde adviseur */
    adviseurs: AdviseurModel[] | null;
    /** Het id van de toegevoegde bemiddelaar */
    bemiddelaars: BemiddelaarModel[] | null;
    code: string | null;
    target: string | null;
    message: string | null;
}

/** Model om de product historie op te halen */
export interface GetProductHistoryApiModel {
    bemiddelingProductId: string;
    hypotheekId: string | null;
    dekkingId: string | null;
}

/** Model die de status van Hdn weergeeft. */
export interface HdnAvailabilityModel {
    /** Status van de HDN API */
    isOnline: boolean;
    /** Datum waarop de status is veranderd. */
    updatedAt: string;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model voor hdn bericht aanvulling. */
export interface HdnBerichtAanvulling {
    /** Id van bemiddelingproduct. */
    bemiddelingProductId: string;
    aanvullingBerichtType: AanvullingBerichtType;
    /** Geeft aan of het aankoop is */
    isAankoop: boolean;
    /** Ontbrekende velden van hdn bericht. */
    ontbrekendeVelden: HdnBerichtOntbrekendVeld[] | null;
}

/** Model voor hdn bericht aanvulling */
export interface HdnBerichtAanvullingResult {
    /** De eventuele validatiemeldingen m.b.t. het HDN bericht */
    validatieMeldingen: HdnValidatiemeldingForm[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface HdnBerichtBemiddeldEventDetails {
    locatieBestand: string | null;
    vestiging: string | null;
    product: string | null;
    berichtType: string | null;
    actor: string | null;
    timeStamp: string | null;
    description: string | null;
    vestigingId: string | null;
}

export interface HdnBerichtExtraInformationDetails {
    reason: string | null;
}

export interface HdnBerichtIncomeEventDetails {
    berichtVersie: string | null;
    pakketnaam: string | null;
    responseBerichtType: string | null;
    documentUrl: string | null;
    kenmerk: string | null;
    extraInformation: HdnBerichtExtraInformationDetails[] | null;
    aanvraagvolgnummer: string | null;
    versie: number | null;
    senderNode: string | null;
    receiverNode: string | null;
    senderName: string | null;
    receiverName: string | null;
    pakketVersie: string | null;
    product: string | null;
    berichtType: string | null;
    actor: string | null;
    timeStamp: string | null;
    description: string | null;
    vestigingId: string | null;
}

/** Ontbrekend veld van een hdn bericht. */
export interface HdnBerichtOntbrekendVeld {
    /** Het volledige XPath. */
    xPath: string | null;
    /** De occurance/index van de parent-node (binnen de nodes met hetzelfde XPath). */
    parentOccurance: number | null;
    /** Waarde van het veld conform het datatype. */
    waarde: any | null;
}

/** Model voor stoppen met opnieuw verzenden van een hdn bericht. */
export interface HdnBerichtStopRetryModel {
    /** Het Id van het hdn bericht dat niet meer opnieuw geprobeerd moet worden. */
    hdnBerichtId: string;
}

export interface HdnBerichtUpdateEventDetails {
    reason: string | null;
    aanvraagvolgnummer: string | null;
    versie: number | null;
    senderNode: string | null;
    receiverNode: string | null;
    senderName: string | null;
    receiverName: string | null;
    pakketVersie: string | null;
    product: string | null;
    berichtType: string | null;
    actor: string | null;
    timeStamp: string | null;
    description: string | null;
    vestigingId: string | null;
}

/** HdnDocumentstatus Aangeleverd = 0, Afgekeurd = 1, Goedgekeurd = 2 */
export enum HdnDocumentstatus {
    Aangeleverd = "Aangeleverd",
    Afgekeurd = "Afgekeurd",
    Goedgekeurd = "Goedgekeurd",
}

/** Bevat een HDN validatiemelding met aanvullende gegevens over het scherm waar het betreffende veld ingevuld kan worden. */
export interface HdnValidatiemeldingForm {
    app: LocatieAppOptions;
    /** Locatie van het scherm binnen de app waar het veld ingevuld kan worden */
    readonly locatie: string | null;
    /** Relatieve URL van het scherm binnen de app waar het veld ingevuld kan worden */
    readonly relativeUrl: string | null;
    /** Gets or sets code */
    code: string | null;
    /** Gets or sets omschrijving */
    omschrijving: string | null;
    /** Gets or sets waarde van het veld waar de validatiemelding
betrekking op heeft */
    waarde: any | null;
    veldInfo: HdnVeldInfo;
    /** Gets or sets de occurance/index van de node (binnen de nodes met
hetzelfde XPath). */
    occurance: number | null;
    /** Gets or sets de occurance/index van de bovenliggende (parent) node
(binnen de nodes met hetzelfde XPath). */
    parentOccurance: number | null;
    /** Gets or sets indien van toepassing: de foutmelding uit de
controle-XML. */
    foutmeldingControleSchema: string | null;
}

/** Bevat gegevens van een veld in een HDN berichtschema. */
export interface HdnVeldInfo {
    /** Gets or sets naam */
    naam: string | null;
    /** Gets or sets omschrijving */
    omschrijving: string | null;
    /** Gets or sets het (HDN) datatype */
    datatype: string | null;
    /** Gets or sets het XPath van het veld */
    xPath: string | null;
    /** Gets or sets indicatie dat het veld altijd verplicht is volgens de
XSD */
    verplicht: boolean | null;
    /** Gets or sets indicatie dat het veld conditioneel verplicht is
volgens de conditie-XML */
    conditioneelVerplicht: boolean | null;
    /** Gets or sets het aantal keer dat het veld mag voor komen, indien
het een entiteit betreft */
    maxOccurs: number | null;
    /** Gets or sets indicatie dat de entiteit niet mag voor komen volgens
de conditie-XML */
    entiteitNietToegestaan: boolean | null;
}

/** Model voor inkomende documenten */
export interface IncomingDocument {
    /** Datum waarop het bericht is ontvangen. */
    ontvangenOp: string;
    /** Locatie van het ontvangen bestand. */
    bestandsLocatie: string | null;
    /** Omschrijving van het ontvangen document. */
    omschrijving: string | null;
    /** Unieke Id van het document */
    documentId: string;
    /** Naam van het document */
    naam: string | null;
    /** Product waar het bericht bij hoort. */
    associatedProduct: string | null;
    /** Locatie van het bestand op de blob */
    bestandBlobLocatie: string | null;
    /** Klantsamenstellingsdocument Id. */
    klantsamenstellingsDocumentId: string | null;
}

/** Bevat de kantoorgegevens. */
export interface Kantoorgegevens {
    /** Adviseurs */
    readonly adviseurs: DossierBehandelaar[] | null;
    /** Bemiddelaars */
    readonly bemiddelaars: DossierBehandelaar[] | null;
    /** Gekozen bemiddelaar id */
    readonly gekozenBemiddelaarId: string;
    vestiging: Vestiging;
}

/** Bevat de gegevens van een klantsamenstellingdocument */
export interface KlantsamenstellingdocumentApiModel {
    /** Unieke identificatie van het KlantsamenstellingDocument */
    klantsamenstellingDocumentId: string;
    /** Upload datum van het KlantsamenstellingDocument */
    uploadDatum: string;
    /** Naam van bestand */
    bestandNaam: string | null;
    /** Locatie van bestand */
    bestandLocatie: string | null;
    /** Locatie van bestand op de blob */
    bestandBlobLocatie: string;
    /** Id van de uploadende medewerker */
    medewerkerId: string;
    /** Naam van de uploadende medewerker */
    medewerkerNaam: string | null;
    /** Kenmerken van het document */
    documentKenmerken: string | null;
    documentType: DocumentTypeOptions;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van de klantsamenstellingdocumenten */
export interface KlantsamenstellingdocumentenApiModel {
    /** Bevat gegevens van de aanwezige klantsamenstellingdocumenten */
    klantsamenstellingdocumenten: KlantsamenstellingdocumentApiModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** LocatieAppOptions Advies = 1, Contract = 2, Instellingen = 3 */
export enum LocatieAppOptions {
    Advies = "Advies",
    Contract = "Contract",
    Instellingen = "Instellingen",
}

/** Aan te levern document model. */
export interface NecessaryDocument {
    /** Datum waarvoor het document aangeleverd moet worden. */
    aanTeLeverenVoor: string | null;
    /** Reden van afkeuren van het document */
    afkeurReden: string | null;
    /** Naam van het gekoppelde bestand. */
    gekoppeldBestand: string | null;
    /** Omschrijving van het document. */
    omschrijving: string | null;
    /** Status van het aangeleverde document. */
    status: string | null;
    /** Unieke Id van het document */
    documentId: string;
    /** Naam van het document */
    naam: string | null;
    /** Product waar het bericht bij hoort. */
    associatedProduct: string | null;
    /** Locatie van het bestand op de blob */
    bestandBlobLocatie: string | null;
    /** Klantsamenstellingsdocument Id. */
    klantsamenstellingsDocumentId: string | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model voor uitgaand bericht. */
export interface OutgoingBericht {
    /** Id van het advierdossier */
    hdnBerichtId: string;
    /** Geeft aan of verzending is gelukt */
    isGelukt: boolean;
    /** Datum laatste verzendpoging */
    laatsteVerzendPogingOp: string;
    /** Id van het advierdossier */
    adviesDossierId: string;
    /** Naam van verzonden bericht */
    naam: string | null;
    /** Titel van het verzonden bericht */
    readonly titel: string | null;
    /** De namen van de aanvragers. */
    aanvragerNamen: string[] | null;
    /** Geeft aan of verzending is mislukt door een validatiefout */
    isValidatieFout: boolean;
    /** Geeft aan of verzending is gelezen is in postvak uit */
    isGelezenInPostvakUit: boolean;
}

/** Model met lijst van uitgaande berichten */
export interface OutgoingBerichtListModel {
    /** Lijst met uitgaande berichten */
    uitgaandeBerichten: OutgoingBericht[] | null;
    /** Geeft aan of er ongelezen berichten zijn */
    readonly bevatOngelezenBerichten: boolean;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Model voor product history */
export interface ProductHistoryListModel {
    /** Product versies */
    products: ProductHistoryModel[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Product versie */
export interface ProductHistoryModel {
    /** Datum van het product. */
    aanmaakDatum: string;
    /** Verzenddatum van het product. */
    verzondenOpDatum: string | null;
    /** Maatschappij naam. */
    maatschappij: string | null;
    /** Versie van het product */
    versie: number;
    status: ProductStatus;
}

/** Bevat het id van het te verzenden bemiddelingproduct */
export interface ProductSendApiModel {
    /** Het id van het adviesdossier */
    adviesdossierId: string;
    /** Het id van het bemiddelingproduct */
    bemiddelingproductId: string;
    /** Geeft aan of de validatie na het updaten van de data geskipt moet worden.
Dit zou alleen op true gezet moeten worden vanuit AanvragenTests, aangezien hier een test aanwezig is
waar een foutief bericht naar HDN verzonden wordt. */
    skipValidation: boolean;
}

/** ProductStatus In = 0, Uit = 1 */
export enum ProductStatus {
    In = "In",
    Uit = "Uit",
}

/** Het input model waarmee het bemiddelingproduct wordt aangepast */
export interface ProductStatusApiModel {
    status: BemiddelingProductStatus;
    /** Het id van het bemiddelingproduct */
    bemiddelingproductId: string;
}

/** De output van het aanpassen van een productstatus */
export interface ProductStatusOutputApiModel {
    /** Het id van een bemiddelingproduct */
    productId: string;
    code: string | null;
    target: string | null;
    message: string | null;
}

/** Bevat de gegevens van bemiddelde producten */
export interface Producten {
    /** Bevat de bemiddelde producten */
    readonly bemiddelingProducten: BaseProduct[] | null;
}

/** Output voor het opvragen van bemiddeling producten */
export interface ProductenOutput {
    /** Lijst met bemiddeling producten */
    producten: { [key: string]: Producten; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Aangeleverd document model. */
export interface ProvidedDocument {
    /** Datum van laatste wijziging. */
    laatstGewijzigdOp: string | null;
    /** Reden van afkeuren van het document */
    afkeurReden: string | null;
    /** Naam van het gekoppelde bestand. */
    gekoppeldBestand: string | null;
    /** Omschrijving van het document. */
    omschrijving: string | null;
    /** Status van het aangeleverde document. */
    status: string | null;
    /** Unieke Id van het document */
    documentId: string;
    /** Naam van het document */
    naam: string | null;
    /** Product waar het bericht bij hoort. */
    associatedProduct: string | null;
    /** Locatie van het bestand op de blob */
    bestandBlobLocatie: string | null;
    /** Klantsamenstellingsdocument Id. */
    klantsamenstellingsDocumentId: string | null;
}

/** Output zetten van een bemiddelaar */
export interface SetBemiddelaarInputApiModel {
    /** Id van het adviesdossier */
    adviesdossierId: string;
    /** Id van de bemiddelaar */
    bemiddelaarId: string | null;
    /** Emailadres van de bemiddelaar, indien er geen id beschikbaar is. */
    bemiddelaarEmailadres: string | null;
}

/** De output van het aanpassen van een productstatus */
export interface SetBemiddelaarOutputApiModel {
    /** Het id van de toegevoegde bemiddelaar */
    bemiddelaarId: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output zetten van een default bemiddelaar */
export interface SetDefaultBemiddelaarInputApiModel {
    /** Id van de adviseur */
    adviseurId: string;
    /** Id van de bemiddelaar */
    bemiddelaarId: string | null;
    /** Het emailadres van de bemiddelaar, indien er geen id beschikbaar is. */
    bemiddelaarEmailadres: string | null;
}

/** Model de status van een dossier aan te passen */
export interface SetDossierStatusApiModel {
    /** Id van het adviesdossier */
    adviesdossierId: string;
    status: Dossierstatus;
}

/** Model om bestanden te updaten. */
export interface UpdateDocumentApiModel {
    /** Id van het adviesdossier */
    adviesdossierId: string;
    /** Id van het klantsamenstellingdocument */
    klantsamenstellingdocumentId: string;
    /** Locatie van het bestand */
    bestandLocatie: string | null;
    /** Naam van het bestand */
    bestandNaam: string | null;
}

/** Model voor het updaten van de receiver node. */
export interface UpdateReceiver {
    /** Het nodenummer van de ontvanger. */
    receiverNode: string | null;
}

/** Model om bestanden te uploaden. */
export interface UploadApiModel {
    /** Bestanden */
    bestanden: string[] | null;
    /** Bestandlocaties */
    bestandLocaties: string[] | null;
}

/** Api model met result van het uploaden van bestanden. */
export interface UploadResultApiModel {
    /** File ids */
    fileIds: string[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface Vestiging {
    naam: string | null;
    bezoekadres: AdresInput;
    postadres: AdresInput;
    emailadres: string | null;
    telefoonnummer: string | null;
    platformId: string | null;
    afmRegistratienummer: string | null;
    isHoofdvestiging: boolean | null;
    organisatieId: string | null;
}